import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FunctionComponent } from "react";
import { styled } from "@iventis/styles";
import { InteractiveElement } from "@iventis/styles/src/components";

interface ItemOptionsProps {
    itemOptions: ItemOption[];
    itemId: string;
    show: boolean;
}

export interface ItemOption {
    id: string;
    icon: IconProp;
    name: string;
    show?: boolean;
    onClick: (id: string) => void;
}

/**
 * A component which displays item options for a single item
 * @param {ItemOption[]} itemOptions - an array which contains the icon to display whether the icon should be show and a handle click event function which emits the id of the item
 * @param {string} itemId - the id of the parent item
 * @param {boolean} show - if the icon should be shown can be overruled by the itemOptionShow property
 */
export const ItemOptionsComponent: FunctionComponent<ItemOptionsProps> = ({ itemOptions, itemId, show }) => (
    <ItemOptionStyle>
        {itemOptions.map(
            (option) =>
                (show || option.show) && (
                    <InteractiveElement
                        key={option.id}
                        onClick={(event) => {
                            option.onClick(itemId);
                            event.stopPropagation();
                        }}
                    >
                        <span className="hidden">{option.name}</span>
                        <FontAwesomeIcon icon={option.icon} style={{ marginRight: "10px", width: "22px" }} />
                    </InteractiveElement>
                )
        )}
    </ItemOptionStyle>
);

const ItemOptionStyle = styled.div`
    display: flex;
    justify-content: flex-end;
    flex-shrink: 1;
`;
